import React, { Component } from 'react';
import "./footer.css";
import {
  subscribe
} from "../../redux/actions";
class Footer extends Component {
  constructor(props){
    super(props);
    this.state={
      newsletter:""
    }
  }
  handlePointerChange = () => {
    let aboutBorisAndMatthew = document.querySelector('#aboutBorisAndMatthew');
    // let ourPartners = document.querySelector('#ourPartners');
    let ourClient = document.querySelector('#ourClient');
    // let downloadOrderFormGuidline = document.querySelector('#downloadOrderFormGuidline');
    let faqs = document.querySelector('#faqs');
    let privacy = document.querySelector('#privacy');
    aboutBorisAndMatthew.style.cursor = 'pointer';
    // ourPartners.style.cursor = 'pointer';
    ourClient.style.cursor = 'pointer';
    // downloadOrderFormGuidline.style.cursor = 'pointer';
    faqs.style.cursor = 'pointer';
    privacy.style.cursor = 'pointer';
    let facebook = document.querySelector('#facebook');
    let instagram = document.querySelector('#instagram');
    facebook.style.cursor = 'pointer';
    instagram.style.cursor = 'pointer';
  }

  handleAboutBorisAndMatthewClick = () => {
    window.location.href = '/about-boris-and-matthew';
  }

  handleOurPartnersClick = () => {
    window.location.href = '/our-partners';
  }

  handleOurClientClick = () => {
    window.location.href = '/our-client';
  }

  handleFollowUsFacebookClick = () => {
    window.location.href = 'https://www.facebook.com/BorisnMatthew/';
  }

  handleFollowUsInstagramClick = () => {
    window.location.href = 'https://www.instagram.com/borisnmatthew/';
  }
  handleConditionsClick = () =>{
    window.location.href = '/conditions';
  }
  handlePrivacyPolicyClick = () => {
    window.location.href = '/privacy';
  }
  subscribe = () => {
    subscribe(this.state.newsletter);
    this.setState({newsletter:''});
    alert("Subscribed Successfully");
  }

  render() {
    return (
      <div className="footer">
      <div className='phantom'/>
        <div className="col-md-3 column">
            <ul>
                <span className="footerCaption">About Us</span>
                <li id="aboutBorisAndMatthew" onClick={this.handleAboutBorisAndMatthewClick} onMouseEnter={this.handlePointerChange}>About Boris & Matthew</li>
                {/*<li id="ourPartners" onClick={this.handleOurPartnersClick} onMouseEnter={this.handlePointerChange}>Our Partners</li>*/}
                <li id="ourClient" onClick={this.handleOurClientClick} onMouseEnter={this.handlePointerChange}>Our Clients</li>
                {/* <li id="downloadOrderFormGuidline" onMouseEnter={this.handlePointerChange}>Download Order Form Guidline</li> */}
                <li id="faqs" onMouseEnter={this.handlePointerChange} onClick={this.handleConditionsClick}>Conditions</li>
                <li id="privacy" onClick={this.handlePrivacyPolicyClick} onMouseEnter={this.handlePointerChange}>Privacy Policy</li>
                <br/>
                <li>All copyright &copy; <b>Boris & Matthew</b></li>
            </ul>
        </div>
        <div className="col-md-4=3 column">
          <ul>
              <span className="footerCaption">Contact Us</span>
              <li><i className="fa fa-envelope" aria-hidden="true"></i><div style={{marginBottom:16,display:"inline-block"}}>info@bnm.hk</div></li>
              <li><i className="fa fa-phone" aria-hidden="true"></i><div style={{marginBottom:16,display:"inline-block"}}>+852 2854 2834</div></li>
              <li><i className="fab fa-whatsapp" aria-hidden="true"></i><div style={{marginBottom:16,display:"inline-block"}}>+852 9164 2834</div></li>
              <li><i className="fa fa-fax" aria-hidden="true"></i><div style={{marginBottom:16,display:"inline-block"}}>+852 2854 2844</div></li>
              <li><i className="fa fa-map-marker" aria-hidden="true"></i><div style={{marginBottom:3,display:"inline-block"}}>4C, E.Wah Factory Building</div><br/></li>
              <li><div style={{marginLeft:20, marginBottom:3,display:"inline-block"}}>56-60 Wong Chuk Hang Road</div></li>
              <li><div style={{marginLeft:20, marginBottom:16,display:"inline-block"}}>Hong Kong</div></li>
          </ul>
        </div>
        <div className="col-md-3 column">
          <ul>
            <span className="footerCaption">Opening Hours</span>
            <li><i className="fa fa-clock-o" aria-hidden="true"></i><div style={{marginBottom:3,display:"inline-block", marginLeft:-4}}>Monday to Saturday </div></li>
            <li><div style={{marginBottom:3,marginLeft:20}}>9:00 AM - 6:00 PM</div></li>
            <li><div style={{marginBottom:3,marginLeft:20}}>Closed on Sunday and</div></li>
            <li><div style={{marginBottom:16,marginLeft:20}}>Public Holidays</div></li>
            <li><div style={{marginBottom:3,marginLeft:20}}>(Deliveries are available everyday including public holidays, orders have to be confirmed within shop opening hours.)</div></li>
          </ul>
        </div>
        <div className="col-md-3 column">
          <div>
            <span className="footerCaption">Newsletter</span><br />
            <input type="text" style={{color:"black"}}value={this.state.newsletter} onChange={(text)=>{this.setState({newsletter:text.target.value})}} />
            <button onClick={()=>this.subscribe()} style={{margin:10, color:'#4A4A4A', padding:2}}>Subscribe</button>
          </div>
          <div>
            <span className="footerCaption">Follow Us</span><br />
            <i id="facebook" className="fab fa-facebook-f" aria-hidden="true" onClick={this.handleFollowUsFacebookClick} onMouseEnter={this.handlePointerChange}></i>
            <i id="instagram" className="fab fa-instagram" aria-hidden="true" onClick={this.handleFollowUsInstagramClick} onMouseEnter={this.handlePointerChange}></i>
          </div>
        </div>
      </div>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/footer/footer.js